import _ from 'lodash';

export function getPrevalenceTableData(clinicalSummary: any, counts: any) {
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  const data = [];

  if (counts) {
    const allPatientsCount = clinicalSummary.patient.count;
    counts
      .filter((item: any) => {
        return item.display && item.display.toLowerCase() !== 'unknown';
      })
      .forEach((item: any) => {
        const itemPatientCount = item.patient_count;
        const prevalence =
          Math.round((itemPatientCount / allPatientsCount) * 1000) / 10;
        const prevalenceFormated = `${prevalence}%`;

        data.push({
          name: item.display,
          patients: itemPatientCount,
          prevalence: prevalenceFormated,
        });
      });
  }
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  return data;
}

export function getPatientStatusData(omicsSummary: any) {
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  const values = [];
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  const labels = [];

  omicsSummary?.is_deceased?.forEach((status: any) => {
    values.push(status.count);
    labels.push(status.display === 'false' ? 'Living' : 'Deceased');
  });

  return [
    {
      // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
      values: values,
      // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
      labels: labels,
      type: 'pie',
      hole: 0.5,
      textinfo: 'value',
      hoverinfo: 'label+value',
    },
  ];
}

export function getPatientAgeData(data: any) {
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  const bars = [];

  data?.forEach((d: any) => {
    if (!d.demographic_value) {
      return;
    }

    bars.push({
      name: d.display,
      type: 'bar',
      x: [d.display],
      y: [d.count],
      showlegend: false,
    });
  });

  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  return bars;
}

export function getPatientPieData(data: any) {
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  const values = [];
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  const labels = [];

  data?.forEach((d: any) => {
    values.push(d.count);
    labels.push(d.display);
  });

  return [
    {
      // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
      values: values,
      // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
      labels: labels,
      type: 'pie',
      hole: 0.5,
      textinfo: 'value',
      hoverinfo: 'label+value',
    },
  ];
}

export function getPatientBarData(data: any) {
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  const bars = [];

  data?.forEach((d: any) => {
    bars.push({
      name: d.display,
      type: 'bar',
      x: [d.display],
      y: [d.count],
      showlegend: false,
    });
  });

  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  return bars;
}

export function getPatientCountData(clinicalSummary: any, title: any) {
  const data = [];
  if (clinicalSummary.patient) {
    data.push({
      type: 'indicator',
      value: clinicalSummary.patient.count,
      title: { text: title },
    });
  }
  return data;
}

export function getMediaTableData(mediaCounts: any) {
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  const data = [];

  if (mediaCounts) {
    mediaCounts
      .filter((media: any) => {
        return media.media_type && media.media_type.toLowerCase() !== 'unknown';
      })
      .forEach((media: any) => {
        data.push({
          name: media.media_type,
          count: media.media_type_count,
        });
      });
  }
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  return data;
}
